import React from 'react'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Insurance from './ServicingMotInsurance/Insurance'
import MOTs from './ServicingMotInsurance/MOT'
import Services from './ServicingMotInsurance/Services'

const ServicingSection = () => (
  <Stack spacing={2.5} divider={<Divider sx={{ opacity: 0.6 }} />}>
    <Services />
    <MOTs />
    <Insurance />
  </Stack>
)

export default ServicingSection
